import { ProgressBar, eProgressBarDir } from "../../Utils/UI Elements/ProgressBar";
import { ActiveBonus } from "../Bonuses/ActiveBonus";
import { eBonusUID } from "../Bonuses/Bonus";
import { Game, eAtlas_0 } from "../../Game";
import { BonusManager } from "../Bonuses/BonusManager";



export class BonusBar {
    private _bar: ProgressBar;
    private _pos: pc.Vec3;

    /**
     * (RO) Aktivni bonus nebo undefined
     */
    get actBonus(): ActiveBonus { return this._actBonus; }
    private _actBonus: ActiveBonus;

    /**
     * (RO) UID bonusu, pro ktery je bar urcen
     */
    get bonusUID(): eBonusUID { return this._bonusUID; }
    private _bonusUID: eBonusUID;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(hud: pc.Entity, y: number, bonusUID: eBonusUID, barFrameKey: string, barFillFrameKey: string) {
        // Pruh
        this._bar = new ProgressBar(Game.APP.assets.find(eAtlas_0.NAME, pc.eAssetType.atlas).resource as pc.TextureAtlas, barFrameKey, barFillFrameKey, 4, 8, eProgressBarDir.verticalU);
        this._pos = new pc.Vec3(0, y, 0);
        hud.addChild(this._bar.entity);

        this._bonusUID = bonusUID;

        // Sledovat aktivaci a deaktivaci bonusu
        BonusManager.instance.events.on(BonusManager.EVENT_BONUS_ACTIVATE + bonusUID, this.handleBonusAct, this);
        BonusManager.instance.events.on(BonusManager.EVENT_BONUS_DEACTIVATE + bonusUID, this.handleBonusDeact, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._bar.entity.enabled = false;
        this._actBonus = undefined;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    setX(x: number): void {
        this._pos.x = x;
        this._bar.entity.setLocalPosition(this._pos);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._actBonus)
            this._bar.state = this._actBonus.progress;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBonusAct(bonus: ActiveBonus): void {
        this._bar.entity.enabled = true;
        this._actBonus = bonus;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBonusDeact(): void {
        this.reset();
    }
}